import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
// Use this for general navigation dropdowns, not for specialized movie notification dropdowns
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Add event listener for clicks outside the dropdown
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }

  toggle(event) {
    // Prevent any default behavior
    event.preventDefault();
    event.stopPropagation();

    // Toggle the menu visibility
    this.menuTarget.classList.toggle("hidden");
  }

  handleOutsideClick(event) {
    // Only run if we have a menu target and it's visible
    if (
      this.menuTarget &&
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
